var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88157",
    "data-name": "Group 88157",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 430.3,
    height: 431,
    viewBox: "0 0 430.3 431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25653",
    "data-name": "Rectangle 25653",
    width: 430.3,
    height: 431,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88156",
    "data-name": "Group 88156",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308591",
    "data-name": "Path 308591",
    d: "M4.92,352.853c12.585,30.821,42.07,45.371,60.913,54.672,74.279,36.654,187.19,32.211,268.552-34.915C353.425,356.9,448.8,259.33,427.111,148.087,407.938,49.745,319.852,7.074,227.7.6,159.874-4.168,71.527,19.332,40.2,79.377c-19.7,37.758,3.9,49.714-12.281,135.233-14,74.02-38.393,100.544-23,138.243",
    transform: "translate(-0.001 0.001)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308592",
    "data-name": "Path 308592",
    d: "M69.889,200.142c-6.049,0-15.654-1.153-27.095-6.644-11.1-5.327-21.259-13.456-30.189-24.164a.78.78,0,0,1,1.2-1c23.4,28.06,48.828,30.248,56.09,30.248h.015a.779.779,0,0,1,0,1.558Z",
    transform: "translate(14.35 194.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308593",
    "data-name": "Path 308593",
    d: "M79.659,213.821c-2.431,0-11.954-.349-24.625-5.3-13.286-5.194-32.607-16.671-49.207-41.859a.779.779,0,1,1,1.3-.858c16.376,24.845,35.4,36.154,48.475,41.266,14.128,5.523,24.487,5.189,24.589,5.187A.763.763,0,0,1,81,213a.781.781,0,0,1-.748.808c-.056,0-.254.009-.59.009",
    transform: "translate(6.58 191.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308594",
    "data-name": "Path 308594",
    d: "M190.169,117.838a.764.764,0,0,1-.228-.034.778.778,0,0,1-.517-.972,91.266,91.266,0,0,0,3.939-33.9.776.776,0,0,1,.715-.836.789.789,0,0,1,.836.715,92.8,92.8,0,0,1-4,34.476.776.776,0,0,1-.743.552",
    transform: "translate(218.745 94.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308595",
    "data-name": "Path 308595",
    d: "M193.417,136.9a.746.746,0,0,1-.272-.05.778.778,0,0,1-.457-1c7.706-20.643,9.042-41.169,3.965-61.008a.779.779,0,0,1,1.509-.386c5.157,20.154,3.806,40.992-4.017,61.939a.779.779,0,0,1-.728.506",
    transform: "translate(222.498 85.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308596",
    "data-name": "Path 308596",
    d: "M8.7,166.777a5.212,5.212,0,1,1,1.17-10.29,5.212,5.212,0,0,1-1.17,10.29m-.823-1.651a3.655,3.655,0,1,0-2.741-4.383,3.657,3.657,0,0,0,2.741,4.383",
    transform: "translate(4.026 180.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308597",
    "data-name": "Path 308597",
    d: "M36.519,74.221a.857.857,0,0,1-.179-.019.779.779,0,0,1-.58-.937l.743-3.176a.778.778,0,1,1,1.515.356l-.741,3.176a.779.779,0,0,1-.759.6",
    transform: "translate(41.279 80.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308598",
    "data-name": "Path 308598",
    d: "M37.726,69.06a.822.822,0,0,1-.177-.019.778.778,0,0,1-.582-.935l.741-3.179a.779.779,0,0,1,1.517.353l-.741,3.179a.779.779,0,0,1-.759.6",
    transform: "translate(42.673 74.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308599",
    "data-name": "Path 308599",
    d: "M42.324,70.345a.8.8,0,0,1-.172-.019L38.967,69.6a.779.779,0,1,1,.347-1.519l3.183.724a.779.779,0,0,1-.172,1.539",
    transform: "translate(44.307 78.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308600",
    "data-name": "Path 308600",
    d: "M37.154,69.168a.783.783,0,0,1-.172-.019L33.8,68.425a.779.779,0,0,1,.345-1.519l3.183.724a.779.779,0,0,1-.172,1.539",
    transform: "translate(38.338 77.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308601",
    "data-name": "Path 308601",
    d: "M1.839,74.142C.607,62.833.973,46.649,10.285,32.859c25.75-38.135,104.483-35.12,120.7-5.157,8.23,15.206.541,37.693-11.6,50.319C101.439,96.69,70.2,97.494,50.8,87.215c-18.473-9.79-24.711-28.83-36.178-26.681C8.248,61.727,4.2,68.733,1.839,74.142",
    transform: "translate(1.535 5.472)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308602",
    "data-name": "Path 308602",
    d: "M18.989,24.113a.778.778,0,0,1-.024-1.556l66.148-2.064a.778.778,0,1,1,.05,1.556L19.015,24.113h-.026",
    transform: "translate(21.034 23.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308603",
    "data-name": "Path 308603",
    d: "M26.243,28.739a.778.778,0,0,1-.024-1.556L59.5,26.142a.779.779,0,0,1,.047,1.558l-33.28,1.039h-.026",
    transform: "translate(29.412 30.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308604",
    "data-name": "Path 308604",
    d: "M136.492,122.187c1.608-2.418,19.705-30.64,6.814-61.777-9.051-21.86-30.873-39.122-55.595-39.314-4.168-.032-30.472-.239-43.91,21.184-9.053,14.428-9.476,34.2.2,48.281,11.5,16.727,32.517,18.507,35.637,18.723,21.819,1.509,33.374-12.82,45.449-6.452,7.387,3.894,10.182,13.014,11.4,19.356",
    transform: "translate(42.593 24.362)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308605",
    "data-name": "Path 308605",
    d: "M47.784,40.811l62.185-1.942Z",
    transform: "translate(55.191 44.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308606",
    "data-name": "Path 308606",
    d: "M48.2,42.007a.778.778,0,0,1-.024-1.556l62.187-1.942a.766.766,0,0,1,.8.754.778.778,0,0,1-.754.8L48.226,42.007H48.2",
    transform: "translate(54.772 44.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308607",
    "data-name": "Path 308607",
    d: "M56.953,43.62l22.25-.694Z",
    transform: "translate(65.781 49.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308608",
    "data-name": "Path 308608",
    d: "M57.369,44.817a.778.778,0,0,1-.024-1.556l22.25-.7a.779.779,0,0,1,.047,1.558L57.4,44.817h-.026",
    transform: "translate(65.362 49.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308609",
    "data-name": "Path 308609",
    d: "M63.618,119.344C61.1,112.8,57.444,98.7,54.737,94.29a39.993,39.993,0,0,0-11.3-12.135C40.7,80.179,35.094,76.371,30.7,74.889s-2.991,7.267.916,9.07,6.81,4.825,5.663,5.512a7.387,7.387,0,0,1-7.092,1.392,10.068,10.068,0,0,1-6.853-10.607,13.222,13.222,0,0,1,.433-2.431,10.554,10.554,0,0,0-5.1-12.391,13.913,13.913,0,0,0-7.84-1.407c-4.937.493-7.892,28.224,10.157,38.378,3.735,2.1,19.4,6.39,22.375,11.1s5.984,13.88,5.984,13.88Z",
    transform: "translate(8.159 73.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308610",
    "data-name": "Path 308610",
    d: "M49.319,128.95l-.3-.9c-.03-.09-3.015-9.129-5.9-13.708-1.927-3.047-10.008-6.079-15.91-8.292A56.516,56.516,0,0,1,21.02,103.5C7.469,95.877,5.411,78.738,7.3,69.728c.782-3.735,2.157-5.89,3.87-6.058a14.689,14.689,0,0,1,8.269,1.487,11.356,11.356,0,0,1,5.5,13.3,12.429,12.429,0,0,0-.405,2.289,9.317,9.317,0,0,0,6.306,9.792,6.294,6.294,0,0,0,6.056-1.043l.254-.175c-.241-.692-2.159-2.724-5.437-4.232-3.108-1.437-4.819-6.515-3.782-9.12a2.5,2.5,0,0,1,3.442-1.4c4.446,1.5,10.016,5.263,12.943,7.374A40.985,40.985,0,0,1,55.821,94.3c1.75,2.851,3.8,9.379,5.788,15.691,1.146,3.64,2.228,7.079,3.155,9.488l.241.627ZM12.8,65.143c-.485,0-.976.028-1.474.075-.735.073-1.83,1.616-2.5,4.829-1.8,8.579.134,24.882,12.96,32.1a56.247,56.247,0,0,0,5.974,2.446c6.448,2.418,14.473,5.426,16.68,8.92,2.476,3.92,4.922,10.713,5.762,13.156l12.874-7.256c-.888-2.4-1.892-5.59-2.948-8.952-1.866-5.931-3.98-12.654-5.631-15.344A39.016,39.016,0,0,0,43.4,83.2c-2.853-2.058-8.277-5.722-12.529-7.159-1.009-.338-1.323.06-1.5.5-.694,1.741.547,6,2.989,7.127,2.989,1.379,6.273,3.946,6.366,5.683a1.285,1.285,0,0,1-.629,1.209c-.084.047-.187.123-.312.211a7.9,7.9,0,0,1-7.411,1.252,10.878,10.878,0,0,1-7.4-11.417,13.963,13.963,0,0,1,.459-2.573,9.8,9.8,0,0,0-4.709-11.486,12.939,12.939,0,0,0-5.933-1.4",
    transform: "translate(7.739 73.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308611",
    "data-name": "Path 308611",
    d: "M22.145,104.384,51.959,85.478s51.653,69.882,68.609,74.83,45.658,7.124,45.658,7.124,18,44.79-20.617,64.437C84.058,263.188,22.145,104.384,22.145,104.384",
    transform: "translate(25.577 98.727)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308612",
    "data-name": "Path 308612",
    d: "M124.994,266.853l155.065,20.731c-7.008-22.4-9.141-57.185-3.271-79.925C291.05,152.4,296.232,104.041,266.381,92.43a250.735,250.735,0,0,0-25.94-8.308c-30.855-8.267-88.26-7.859-119.4,12.911C71.6,130.013,59.135,201.572,59.135,201.572l63.9,11.165Z",
    transform: "translate(68.301 91.357)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308613",
    "data-name": "Path 308613",
    d: "M39.288,168.147l.431,7.273a2.3,2.3,0,0,0,1.672,2.077l207.44,58.241a7.4,7.4,0,0,0,6.607-1.336l44.214-37.077-15.479-16.587Z",
    transform: "translate(45.378 194.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308614",
    "data-name": "Path 308614",
    d: "M251.238,237.207a8.163,8.163,0,0,1-2.2-.3L41.6,178.664a3.075,3.075,0,0,1-2.241-2.78l-.431-7.273a.777.777,0,0,1,.817-.823L284.63,180.379a.786.786,0,0,1,.53.248l15.477,16.585a.778.778,0,0,1-.067,1.127l-44.214,37.077a8.21,8.21,0,0,1-5.118,1.791m-210.7-67.82.377,6.4a1.52,1.52,0,0,0,1.106,1.373L249.458,235.4a6.635,6.635,0,0,0,5.913-1.194l43.57-36.538-14.706-15.755Z",
    transform: "translate(44.96 193.793)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308615",
    "data-name": "Path 308615",
    d: "M39.288,186.813,249.92,243.847a6.576,6.576,0,0,0,5.918-1.289L302.982,203.4,103.968,151.986Z",
    transform: "translate(45.378 175.544)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308616",
    "data-name": "Path 308616",
    d: "M211.979,154.524,192.7,189.532a6.548,6.548,0,0,1-8.924,2.588l-12.139-6.385a18.493,18.493,0,0,0-5.1-1.8,10.888,10.888,0,0,0-9.055,2.274l-18.755,15.352c-9.422,10.159,11.258,12.365,15.4,11.919l7.111-.765a56.221,56.221,0,0,1,14.124,2.571c6.282,2.245,15.15,3.663,24.235.435l.711-.252a26.455,26.455,0,0,0,13.268-10.447l23.132-35.329Z",
    transform: "translate(157.42 178.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308617",
    "data-name": "Path 308617",
    d: "M188.9,218.8a40.416,40.416,0,0,1-13.376-2.358,55.445,55.445,0,0,0-13.837-2.524l-7.053.756c-2.457.259-15.5-.47-18.214-5.883-1.082-2.157-.353-4.627,2.164-7.34a.843.843,0,0,1,.078-.073l18.755-15.35a11.6,11.6,0,0,1,9.7-2.435,19.1,19.1,0,0,1,5.323,1.881l12.124,6.379a5.771,5.771,0,0,0,7.879-2.278l19.279-35.006a.778.778,0,0,1,.483-.377.766.766,0,0,1,.606.088l24.729,15.169a.767.767,0,0,1,.353.493.78.78,0,0,1-.108.595l-23.134,35.329a27.384,27.384,0,0,1-13.658,10.758l-.711.252A33.907,33.907,0,0,1,188.9,218.8m-27.237-6.441h.032a56.455,56.455,0,0,1,14.352,2.616c4.644,1.659,13.9,3.92,23.711.435l.711-.252a25.831,25.831,0,0,0,12.878-10.141l22.692-34.659-23.349-14.322L193.8,190.324a7.325,7.325,0,0,1-9.984,2.894L171.7,186.842a17.806,17.806,0,0,0-4.894-1.726,10.062,10.062,0,0,0-8.407,2.114l-18.712,15.318c-2,2.17-2.631,4.034-1.877,5.543,2.06,4.107,13.423,5.383,16.656,5.034l7.111-.765c.028,0,.056,0,.084,0",
    transform: "translate(157 178.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308618",
    "data-name": "Path 308618",
    d: "M159.246,176.086c33.487,5.23,27.81,36.014,27.81,36.014l-7,46.572,33.605,21.862S281,208.111,252.734,149.92c-23.412-48.194-105.022-67.191-105.022-67.191Z",
    transform: "translate(170.607 95.552)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308619",
    "data-name": "Path 308619",
    d: "M121.507,86.463c-3.713-1.7-5.637,1.131-11.172.364a19.239,19.239,0,0,1-14.775-11.65C92.633,67.406,96.856,60,99.52,55.332c2.649-4.644,6.019-9.818,11.868-12.051,7.627-2.911,10.816,1.558,19.546-1.185,7.1-2.23,6.579-5.689,12.9-7.5,5.267-1.513,20.449-.649,23.845,7.5,2.155,5.174-2.493,8.323-.177,15.988,1.392,4.6,3.579,5.166,5.176,8.719,3.959,8.816-1,24.3-10.452,29.489-12.818,7.04-34.312-6.892-40.719-9.829",
    transform: "translate(109.226 39.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308620",
    "data-name": "Path 308620",
    d: "M124.072,73.2,121.09,97.927a11.518,11.518,0,0,1-8.471,9.788l-8.592,2.769a2.135,2.135,0,0,0-.539,3.791c21.707,14.367,51.658,14.113,72.438-1.812l2.431-1.864a2.414,2.414,0,0,0-.92-4.265l-10.628-2.4a11.5,11.5,0,0,1-8.764-9.228l-6.5-36.435Z",
    transform: "translate(118.451 67.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308621",
    "data-name": "Path 308621",
    d: "M139.119,125.973a64.668,64.668,0,0,1-35.644-10.631,2.86,2.86,0,0,1-1.254-2.8,2.894,2.894,0,0,1,1.985-2.383l8.592-2.769a10.7,10.7,0,0,0,7.937-9.139l2.983-24.733a.777.777,0,0,1,.4-.59L151.587,58a.779.779,0,0,1,1.138.547l6.5,36.435a10.7,10.7,0,0,0,8.17,8.607l10.631,2.4a3.193,3.193,0,0,1,1.222,5.642l-2.433,1.864a61.928,61.928,0,0,1-37.7,12.475m-13.9-51.867-2.935,24.332a12.232,12.232,0,0,1-9.045,10.447l-8.551,2.758a1.329,1.329,0,0,0-.92,1.112,1.294,1.294,0,0,0,.571,1.287c21.865,14.473,51.283,13.74,71.535-1.782L178.3,110.4a1.607,1.607,0,0,0,.6-1.653,1.576,1.576,0,0,0-1.215-1.235l-10.631-2.4a12.252,12.252,0,0,1-9.359-9.851l-6.312-35.372Z",
    transform: "translate(118.033 66.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308622",
    "data-name": "Path 308622",
    d: "M146.878,75.461s9.678-4.75,6.275-13.814c-3.11-8.286-9.777-.045-9.777-.045s-5.491-19.873-17.027-12.036a80.908,80.908,0,0,1-22.464,10.687s4.062,20,11.359,33.31c4.4,8.027,9.978,13.617,16.548,10.922,17.99-7.383,15.085-29.024,15.085-29.024",
    transform: "translate(119.988 55.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308623",
    "data-name": "Path 308623",
    d: "M128.846,106.38c-4.832,0-9.48-4.026-13.865-12.025-7.269-13.258-11.4-33.327-11.441-33.53a.78.78,0,0,1,.567-.907,80.922,80.922,0,0,0,22.222-10.577c2.877-1.955,5.672-2.457,8.3-1.489,5.381,1.978,8.452,9.562,9.5,12.652,1.3-1.28,3.732-3.252,6.15-2.862,1.737.282,3.088,1.677,4.017,4.148,3.148,8.385-4.185,13.355-6.178,14.52.293,3.442,1.116,22.444-15.615,29.31a9.567,9.567,0,0,1-3.661.759m-23.63-45.16c.8,3.655,4.739,20.731,11.131,32.388,5.036,9.189,10.275,12.749,15.568,10.575,17.236-7.073,14.639-27.989,14.611-28.2a.779.779,0,0,1,.427-.8c.368-.183,9-4.558,5.89-12.842-.715-1.909-1.661-2.972-2.808-3.157-2.133-.343-4.791,2.284-5.635,3.327a.777.777,0,0,1-1.355-.282c-.03-.106-3.036-10.741-8.95-12.913-2.133-.782-4.45-.34-6.89,1.315A84.143,84.143,0,0,1,105.217,61.22",
    transform: "translate(119.571 54.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308624",
    "data-name": "Path 308624",
    d: "M116.62,86.674l-.565-1.45,15.533-6.06a15.158,15.158,0,0,0,9.357-17.274L139.4,54.515l1.526-.319,1.541,7.374a16.715,16.715,0,0,1-10.318,19.044Z",
    transform: "translate(134.044 62.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308625",
    "data-name": "Path 308625",
    d: "M146.01,67.572a.778.778,0,0,1-.746-.558c-.058-.194-5.864-19.462-18.774-26.265A20.889,20.889,0,0,0,109.73,39.6a.778.778,0,0,1-.481-1.48,22.393,22.393,0,0,1,17.971,1.259c13.495,7.114,19.3,26.384,19.537,27.2a.781.781,0,0,1-.748,1",
    transform: "translate(125.561 42.526)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308626",
    "data-name": "Path 308626",
    d: "M114.6,74.654a4.443,4.443,0,1,1,6.228-.024,4.405,4.405,0,0,1-6.228.024",
    transform: "translate(130.922 77.53)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308627",
    "data-name": "Path 308627",
    d: "M122.7,66.1c-2.575-6.25-.015-13.232,5.715-15.591a38.048,38.048,0,0,1,3.67-1.106c5.243-1.049,9.077,2.582,11.37,8.148,2.472,6,1.679,12.449-3.577,15.061-.22.11-1.83.687-2.067.752-6.5,1.786-12.536-1.015-15.111-7.265",
    transform: "translate(140.566 56.854)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308628",
    "data-name": "Path 308628",
    d: "M123.818,65.309c-2.452-6.3.243-13.23,6.019-15.477s12.447,1.037,14.9,7.336-.244,13.23-6.021,15.477-12.445-1.037-14.9-7.336",
    transform: "translate(141.963 56.739)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308629",
    "data-name": "Path 308629",
    d: "M198.334,273.25,34.4,225.61a5.954,5.954,0,0,1-4.295-5.719V107.548a5.956,5.956,0,0,1,7.618-5.719l163.937,47.638a5.682,5.682,0,0,1,3.92,5.758l-.252,111.6c0,3.969-3.181,7.536-6.993,6.428",
    transform: "translate(34.77 117.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308630",
    "data-name": "Path 308630",
    d: "M110.532,124.045,109,123.6V248.022a5.925,5.925,0,0,0,5.825-5.915V129.766a5.957,5.957,0,0,0-4.295-5.722",
    transform: "translate(125.897 142.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308631",
    "data-name": "Path 308631",
    d: "M96.48,241.826V151.888a10.155,10.155,0,0,0-7.247-9.728L65.246,135a6.536,6.536,0,0,0-8.407,6.262V252.867a5.863,5.863,0,0,0,4.187,5.62l33.433,9.982a5.878,5.878,0,0,0,3.965-.218l29.03-12.294a2.344,2.344,0,0,0-.207-4.394Z",
    transform: "translate(65.649 155.603)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308632",
    "data-name": "Path 308632",
    d: "M101.459,135.077l-42.43-12.71a1.361,1.361,0,0,1-.97-1.3v-3.7a1.386,1.386,0,0,1,1.782-1.327l41.236,12.355a2.113,2.113,0,0,1,1.508,2.026v3.823a.876.876,0,0,1-1.127.84",
    transform: "translate(67.058 133.951)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308633",
    "data-name": "Path 308633",
    d: "M76.059,208.562a.779.779,0,0,1-.778-.778V183.359a.778.778,0,1,1,1.556,0v24.425a.779.779,0,0,1-.778.778",
    transform: "translate(86.95 210.881)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308634",
    "data-name": "Path 308634",
    d: "M96.552,230.721a6.678,6.678,0,0,1-1.9-.276l-33.433-9.984a6.682,6.682,0,0,1-4.743-6.366V169.067a.779.779,0,0,1,1.558,0V214.1a5.12,5.12,0,0,0,3.631,4.875L95.1,228.954a5.1,5.1,0,0,0,1.8.2.787.787,0,0,1,.827.726.774.774,0,0,1-.724.825c-.149.013-.3.015-.446.015",
    transform: "translate(65.232 194.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308635",
    "data-name": "Path 308635",
    d: "M57.256,209.037a.779.779,0,0,1-.778-.778V141.68a7.315,7.315,0,0,1,9.407-7.01l23.987,7.163a11,11,0,0,1,7.8,10.473l-.556,35.749a.761.761,0,0,1-.791.767.778.778,0,0,1-.765-.791l.556-35.739a9.43,9.43,0,0,0-6.691-8.969l-23.989-7.161a5.757,5.757,0,0,0-7.4,5.517v66.579a.779.779,0,0,1-.778.778",
    transform: "translate(65.232 155.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308636",
    "data-name": "Path 308636",
    d: "M75.645,205.366a.778.778,0,0,1-.778-.778l0-30.323a.778.778,0,1,1,1.556,0l0,30.323a.779.779,0,0,1-.778.778",
    transform: "translate(86.471 200.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308637",
    "data-name": "Path 308637",
    d: "M200.152,274.651a5.788,5.788,0,0,1-1.618-.235l-60.683-17.634a.779.779,0,0,1,.435-1.5l60.683,17.634a4.039,4.039,0,0,0,3.659-.683,6.3,6.3,0,0,0,2.338-5l.25-111.6a4.888,4.888,0,0,0-3.357-5.008L37.923,102.995a5.181,5.181,0,0,0-6.624,4.974v112.34a5.208,5.208,0,0,0,3.735,4.974l47.319,13.751a.779.779,0,1,1-.435,1.5L34.6,226.778a6.77,6.77,0,0,1-4.855-6.469V107.968a6.735,6.735,0,0,1,8.614-6.469L202.294,149.14a6.463,6.463,0,0,1,4.48,6.5l-.25,111.6a7.879,7.879,0,0,1-2.963,6.241,5.632,5.632,0,0,1-3.409,1.168",
    transform: "translate(34.353 116.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308638",
    "data-name": "Path 308638",
    d: "M145.982,27.919a28.265,28.265,0,1,1,8.948,38.958,28.265,28.265,0,0,1-8.948-38.958",
    transform: "translate(163.624 16.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308639",
    "data-name": "Path 308639",
    d: "M170.3,72.382a29.035,29.035,0,1,1,24.66-13.617A28.872,28.872,0,0,1,170.3,72.382m.1-56.532a27.665,27.665,0,0,0-6.2.707,27.339,27.339,0,1,0,6.2-.707m-24,12.49h0Z",
    transform: "translate(163.213 16.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308640",
    "data-name": "Path 308640",
    d: "M161.511,49.041l-9.187-5.754A10.91,10.91,0,0,1,148.87,28.25l1.254-2A10.909,10.909,0,0,1,165.161,22.8l9.187,5.756A10.91,10.91,0,0,1,177.8,43.589l-1.254,2a10.907,10.907,0,0,1-15.038,3.452",
    transform: "translate(170.021 24.404)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308641",
    "data-name": "Path 308641",
    d: "M172.015,56.717a3.379,3.379,0,0,1-1.8-.521L146.988,41.647a3.406,3.406,0,0,1-1.08-4.7l10.049-16.04a3.408,3.408,0,0,1,4.7-1.077l23.224,14.548a3.411,3.411,0,0,1,1.078,4.7l-10.047,16.04a3.386,3.386,0,0,1-2.125,1.511,3.469,3.469,0,0,1-.769.088M158.847,20.871a1.857,1.857,0,0,0-.418.047,1.833,1.833,0,0,0-1.153.821L147.23,37.777a1.851,1.851,0,0,0,.584,2.549L171.04,54.877a1.848,1.848,0,0,0,2.547-.586l10.049-16.038a1.852,1.852,0,0,0-.586-2.549L159.826,21.153a1.83,1.83,0,0,0-.978-.282",
    transform: "translate(167.924 22.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308642",
    "data-name": "Path 308642",
    d: "M157.7,35.748a.781.781,0,0,1-.709-.453l-5.237-11.4a.778.778,0,1,1,1.414-.651l5.239,11.4a.779.779,0,0,1-.381,1.032.792.792,0,0,1-.325.071",
    transform: "translate(175.193 26.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308643",
    "data-name": "Path 308643",
    d: "M154.92,29.8a.779.779,0,0,1-.015-1.558l12.538-.259a.8.8,0,0,1,.8.763.781.781,0,0,1-.763.8l-12.538.259Z",
    transform: "translate(178.034 32.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308644",
    "data-name": "Path 308644",
    d: "M104.89,32.146a28.265,28.265,0,1,1,30.78,25.5,28.263,28.263,0,0,1-30.78-25.5",
    transform: "translate(121.003 1.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308645",
    "data-name": "Path 308645",
    d: "M133.4,58.969A29.045,29.045,0,0,1,111.085,11.4a29.042,29.042,0,0,1,44.727,37.057A28.838,28.838,0,0,1,136.161,58.84c-.922.086-1.847.129-2.765.129m.1-56.534q-1.306,0-2.618.123a27.487,27.487,0,0,0,2.547,54.853q1.287,0,2.588-.121A27.488,27.488,0,0,0,150.985,8.758,27.285,27.285,0,0,0,133.5,2.435",
    transform: "translate(120.586 1.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308646",
    "data-name": "Path 308646",
    d: "M135.842,34.459,132.1,29.817a2.1,2.1,0,0,0-1.468-.687l-.629.013a4.583,4.583,0,0,0-1.649.366c-1.478.608-3.864.627-6.982-4.778-3.1-5.372-1.924-7.437-.666-8.42a5.69,5.69,0,0,0,1.347-1.565l.14-.233a2.09,2.09,0,0,0,.14-1.616l-2.146-5.564a1.135,1.135,0,0,0-1.211-.679l-1.384.256a5.179,5.179,0,0,0-3.011,1.694c-3.273,3.821-2.726,11.48,1.666,19.085,4.4,7.624,10.779,11.932,15.729,10.982a5.118,5.118,0,0,0,2.918-1.73l.933-1.1a1.129,1.129,0,0,0,.017-1.386",
    transform: "translate(129.911 7.669)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardClaim);
export default __webpack_public_path__ + "static/media/Dashboard_Claim.039d23eda651f49bf02d59284e87d36c.svg";
export { ForwardRef as ReactComponent };